import { ParentActionTypes } from "./actionTypes";

const initialState = {
    parentListError: null, 
    message: null, 
    isLoadingAddParent: false, 
    isAddNewParentOpen: false,
    loadingParents: false,
    // Add query parameters to the state to act as a single source of truth.
    query: {
        page: 1, 
        pageSize: 20,
        type: '',
        search: ''
    }
}

const account = (state = initialState, action) => {
    switch (action.type) {
        case ParentActionTypes.PARENT_LIST_GET:
            state = {
                ...state,
                parentList: null,
                parentListError: null,
                loadingParents: true
            }
            break;
        case ParentActionTypes.PARENT_LIST_GET_SUCCESSFUL:
            state = {
                ...state,
                parentList: action.payload,
                parentListError: null,
                loadingParents: false
            }
            break;
        case ParentActionTypes.PARENT_LIST_GET_ERROR:
            state = {
                ...state,
                parentList: null,
                parentListError: action.payload,
                loadingParents: false
            }
            break;
        // Handle updating the stored query.
        case ParentActionTypes.SET_PARENT_QUERY:
            state = {
                ...state,
                query: { ...state.query, ...action.payload }
            }
            break;
        case ParentActionTypes.RESET_PARENT_QUERY:
            state = {
                ...state,
                query: initialState.query
            }
            break;
        case ParentActionTypes.PARENT_ADD_MODAL:
            state = {
                ...state,
                isAddNewParentOpen: action.payload,
            }
            break;
        case ParentActionTypes.PARENT_ADD_MODAL_SUCCESS:
            state = {
                ...state,
                isAddNewParentOpen: action.payload,
            }
            break;
        case ParentActionTypes.PARENT_ADD:
            state = {
                ...state,
                isLoadingAddParent: true
            }
            break;
        case ParentActionTypes.PARENT_ADD_SUCCESSFUL:
            state = {
                ...state,
                isLoadingAddParent: false,
                isAddNewParentOpen: false,
            }
            break;
        case ParentActionTypes.PARENT_ADD_ERROR:
            state = {
                ...state,
                isLoadingAddParent: false,
                isAddNewParentOpen: false,
            }
            break;
        case ParentActionTypes.PARENT_REMOVE_SUCCESS:
            state = {
                ...state,
                isLoadingAddParent: false,
                isAddNewParentOpen: false,
            }
            break;
        case ParentActionTypes.PARENT_REMOVE_ERROR:
            state = {
                ...state,
                isLoadingAddParent: false,
                isAddNewParentOpen: false,
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default account;
